import AdminTimesheetActionsDialog from './admin';
import ClientTimesheetActionsDialog from './client';
import ContractorTimesheetActionsDialog from './contractor';

const tenants = {
    admin: AdminTimesheetActionsDialog,
    client: ClientTimesheetActionsDialog,
    contractor: ContractorTimesheetActionsDialog
};

export default tenants;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/dialogs/timesheetActions/tenants/index.jsx